import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean, number } from '@storybook/addon-knobs';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Form group', () => ({
		template: `
		<dms-group :labelMulti="labelGroup" :required="required">
			<dms-input-number :value.sync="valueOd" :wrapp="false" :span="sizeOd" :disabled="disabled" :label="labelOd" />
			<dms-input-number :value.sync="valueDo" :wrapp="false" :span="sizeDo" :disabled="disabled" :label="labelDo" />
		</dms-group>
		`,
		data() {
			return {
				valueOd: 4,
				valueDo: 10,
			};
		},
		computed: {
			sizeOd() {
				return Math.max(1, Math.min(this.size, 24));
			},
			sizeDo() {
				return (24 - this.sizeOd);
			},
		},
		props: {
			size: {
				default: number('Velikost prvního inputu (1-24)', 12),
			},
			required: {
				default: boolean('Povinné', true),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
			labelGroup: {
				default: text('Název skupiny prvků', 'Počet ks od/do'),
			},
			labelOd: {
				default: text('Název prvního prvku (placeholder)', 'Od'),
			},
			labelDo: {
				default: text('Název druhého prvku (placeholder)', 'Do'),
			},
		},
	}), {
		notes: `Jedná se o obalení prvků do grupy a spojení, tedy bez mezer mezi prvky. Interakce mezi prvky není, je třeba případně dodat na
		konkrétním místě nebo vytvořit pro to komponentu.`,
	});
